exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*  DEFINICION DE COLORES BASE */\n.logoEmpresa {\n  position: absolute;\n  bottom: -70px;\n  right: 0; }\nbutton img.btnEnviar {\n  width: 85% !important;\n  right: 34px;\n  top: -15px; }\nbutton[disabled] {\n  margin-left: 35%; }\nbutton img.loading {\n  width: 13px !important;\n  position: absolute;\n  right: 0;\n  top: 10px; }\nlabel.error {\n  color: #9c2740;\n  text-align: left;\n  padding-left: 35px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/autenticacion/lockScreen/css/lock.component.scss
// module id = ../../../../../src/app/autenticacion/lockScreen/css/lock.component.scss
// module chunks = main